import { useEffect, useRef, useState } from 'react';
import useCapture from '../../../hooks/useCapture';

export default function useTeleprompter() {
  const [playing, setPlaying] = useState(false);
  const [speed, setSpeed] = useState(35);
  const [size, setSize] = useState('medium');
  const [mirror, setMirror] = useState(false);
  const [qr, setQr] = useState(false);
  const readRef = useRef(null);
  const videoRef = useRef(null);
  const capture = useCapture(true);
  useEffect(() => { if (videoRef.current) videoRef.current.srcObject = capture.stream; }, [capture.stream]);
  // Scroll at `speed` px/s, clamping frame gaps so a background tab doesn't jump.
  useEffect(() => {
    if (!playing) return;
    let frame, last;
    const step = time => {
      const el = readRef.current;
      if (el && last) {
        el.scrollTop += Math.min(time - last, 60) * speed / 1000;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 2) { setPlaying(false); return; }
      }
      last = time; frame = requestAnimationFrame(step);
    };
    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [playing, speed]);
  const toggleReading = () => {
    const el = readRef.current;
    if (!playing && el && el.scrollTop + el.clientHeight >= el.scrollHeight - 2) el.scrollTop = 0;
    setPlaying(!playing);
  };
  const reset = () => { setPlaying(false); readRef.current.scrollTop = 0; };
  return { playing, speed, setSpeed, size, setSize, mirror, setMirror, qr, setQr, readRef, videoRef, capture, toggleReading, reset };
}
